import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = (ignoreSubpages: boolean, scrollName?: string) => {
  const { pathname } = useLocation();
  const mainPathName = ignoreSubpages ? pathname.split('/')[1] : pathname;
  useEffect(() => {
    scrollToTop(scrollName);
  }, [mainPathName, scrollName]);

  return null;
};

export const scrollToTop = (scrollName?: string) => {
  const scrollAncestor = document.querySelector(scrollName ? '.' + scrollName : '.scroll-ancestor');
  if (scrollAncestor) {
    scrollAncestor.scrollTo({ top: 0, behavior: 'instant' });
  }
};
